/**
 * Tiny wrapper around navigator.vibrate so call sites don't have to
 * feature-detect or guard against environments without vibration. iOS
 * Safari ignores vibrate() entirely; Android Chrome honors it. On
 * unsupported browsers we no-op silently.
 *
 * Use sparingly. The PWA's three legitimate haptic moments:
 *   - Tap a primary action (submit, save flag, capture photo) → tap(20)
 *   - Successful save / sync → success(40, 20, 40)
 *   - Failed save / error → error(80, 40, 80)
 */

function canVibrate(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
}

/** A single short tap (~20ms). Use on primary-action onClick. */
export function tap(): void {
  if (!canVibrate()) return;
  try { navigator.vibrate(20); } catch { /* swallow */ }
}

/** Two-pulse success pattern. Use after a successful save / sync flush. */
export function success(): void {
  if (!canVibrate()) return;
  try { navigator.vibrate([40, 20, 40]); } catch { /* swallow */ }
}

/** Heavier two-pulse error pattern. Use after a failed save / sync error. */
export function error(): void {
  if (!canVibrate()) return;
  try { navigator.vibrate([80, 40, 80]); } catch { /* swallow */ }
}
